import React, { Component } from "react";
import Config from "../../Configuration/Config";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { Card } from "primereact/card";
import "./NoAccess.css";

import { Link } from "react-router-dom";
import { Button } from "primereact/button";

let userSelectedLanguage = localStorage.getItem("selectedLanguage");
class NoAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="Error-Main-Div">
        <center>
          <Card
            title={TranslationFile.noAccess[userSelectedLanguage]}
            className="no-access-card"
          >
            <p className="m-0">
              <Link to="/">
                <Button
                  label={TranslationFile.backToHomeText[userSelectedLanguage]}
                  aria-label={
                    TranslationFile.yearBtnSaveText[userSelectedLanguage]
                  }
                />
              </Link>
            </p>
          </Card>
        </center>
      </div>
    );
  }
}

export default NoAccess;
